import { combineReducers } from 'redux';

// reducer import
import { customizationReducer, LoginReducer } from './customizationReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  sigin: LoginReducer
});

export default reducer;
